import { View } from 'react-native';
import { useUnistyles } from 'react-native-unistyles';
import { memo, useEffect, useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import EmptyListPlaceholder from '@/components/General/EmptyListPlaceholder';
import { LegendList } from "@legendapp/list";
import SongCard from '@/components/Music/SongCard';
import { Query } from '@/utils/react-query/Queries';
import { QueryKeys } from '@/utils/react-query/QueryKeys';
import SearchBox from '@/components/General/inputs/SearchBox';
import { ActivityIndicator } from 'react-native-paper';

export default function SongsScreen(){
    /*** State ***/
    const [searchText, setSearchText] = useState("");
    const [data, setData] = useState([]);

    
    /*** Theme & Dimensions ***/
    const {theme: {colors}} = useUnistyles();


    /*** Queries ***/
    const queryClient = useQueryClient()
    const { data: songs, isFetching } = Query.songs.all()


    /*** Effects ***/
    useEffect(() => {
        if(songs){
            const list = songs.filter((t) => {
                if(searchText != "" && (t.name.toLowerCase().indexOf(searchText.toLowerCase()) === -1 && t.artist.toLowerCase().indexOf(searchText.toLowerCase()) === -1 )){
                    return false;
                }
                else{
                    return true;
                }
            });
            setData(list);
        }
    }, [songs, searchText])


    /*** Functions ***/
    const refreshList = () => {
        queryClient.invalidateQueries({queryKey: QueryKeys.songs.all()});
    }


    const RenderItem = memo(({item}) => {
        return <SongCard song={item}/>;
    })


    const header = (
        <View style={{paddingVertical:10}}>
            <SearchBox
                searchText={searchText}
                onChangeText={(text) => {
                    setSearchText(text);
                }}
            />
        </View>
    )

    return (
        <View style={{flex: 1, alignItems: 'stretch', justifyContent: 'center', paddingHorizontal:10 }}>
            <LegendList recycleItems keyExtractor={(item) => item.id}  
                keyboardShouldPersistTaps="handled"
                estimatedItemSize={200}
                data={isFetching ? [] : data}
                removeClippedSubviews
                renderItem={({item, index}) => <RenderItem item={item} index={index}/>}
                onEndReachedThreshold={0.1}
                windowSize={5}
                refreshing={isFetching}
                onRefresh={refreshList}
                ListHeaderComponent={header}
                ListFooterComponent={!isFetching 
                    ? data.length == 0 ? <EmptyListPlaceholder icon="musical-notes" spacing={10} message="You haven't added any songs, add a new Song with the '+' icon!"/> : <View style={{paddingBottom:30}}></View>
                    : <View style={{alignContent:'center', justifyContent:'center'}}>
                        <ActivityIndicator size="large" color={colors.primary}/>
                    </View>}
            />
        </View>
    )
}